type CurrentPage =
    | 'Fiverr Business Category'
    | 'Business Search'
    | 'Sub Category'
    | 'Search'
    | 'Profession Based Gigs Search'
    | 'Profession Based Roles Search'
    | 'Profession Category';

export const isEligibleForNewImpressions = ({ currentPage }: { currentPage: CurrentPage }) => {
    switch (currentPage) {
        case 'Sub Category':
        case 'Search':
        case 'Profession Based Gigs Search':
        case 'Profession Based Roles Search':
        case 'Fiverr Business Category':
        case 'Business Search':
        case 'Profession Category': {
            return true;
        }

        default: {
            return false;
        }
    }
};
